import React from 'react';
import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from '@stockx/ui';
import { useTranslation } from 'react-i18next';
import ListEditFormWrapper from '../ListEdit/ListEditForm/ListEditFormWrapper';

const ListEditDrawer = () => {
  const { t } = useTranslation();

  return (
    <DrawerContent>
      <DrawerCloseButton />
      <DrawerHeader textAlign="center" borderBottomWidth="1px">
        {t('Edit Your List')}
      </DrawerHeader>
      <DrawerBody>
        <ListEditFormWrapper />
      </DrawerBody>
      <DrawerFooter />
    </DrawerContent>
  );
};

export default ListEditDrawer;
